// Generated by CoffeeScript 2.7.0
var DatePickerContent;

import Year from './picker-view/year.js';

import Month from './picker-view/month.js';

import Day from './picker-view/day.js';

export default DatePickerContent = {
  components: {
    'year-picker-view': Year,
    'month-picker-view': Month,
    'day-picker-view': Day
  },
  props: {
    viewMode: {
      type: Number,
      default: 3
    },
    displayRange: {
      type: Array,
      default: function() {
        return [];
      }
    },
    initValue: {
      type: Date,
      default: function() {
        return new Date();
      }
    }
  },
  template: `<div class="datepicker">
  <slot name="picker-switch-content"></slot>
  <div class="picker-view-container">
    <year-picker-view v-if='viewMode === 1'
                      :displayRange='displayRange'
                      :initValue='initValue'
                      @update='updateYear'/>

    <month-picker-view v-else-if='viewMode === 2'
                      :displayRange='displayRange'
                      :initValue='initValue'
                      @update='updateMonth'/>

    <day-picker-view v-else-if='viewMode === 3'
                      :displayRange='displayRange'
                      :initValue='initValue'
                      @update='updateDay'/>

    <slot name="time-picker" v-else-if='viewMode === 4'></slot>
  </div>
</div>`,
  methods: {
    updateYear: function(y) {
      return this.$emit('updateYear', y);
    },
    updateMonth: function(m) {
      return this.$emit('updateMonth', m);
    },
    updateDay: function(day) {
      return this.$emit('updateDay', day);
    }
  }
};
